import { createFileRoute, redirect } from "@tanstack/react-router";

import {
  hasRolesForCompliance,
  useCanSeeComplianceScreen,
} from "../_compliance/-components/is-compliance-enabled";

export const Route = createFileRoute(
  "/(app)/_main-layout/_transaction-monitoring/transaction-monitoring",
)({
  beforeLoad: ({ context, location }) => {
    if (!hasRolesForCompliance(context.authorities)) {
      throw redirect({ to: "/" });
    }
    const target = location.href.replace(
      /^\/transaction-monitoring/,
      "/compliance",
    );
    throw redirect({ href: target });
  },
  component: TransactionMonitoringRedirectRoute,
});

function TransactionMonitoringRedirectRoute() {
  useCanSeeComplianceScreen();
  return null;
}
